import { Injectable, InjectionToken } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Store } from "@ngrx/store";
import * as fromRoot from "@core/store/reducers";
import { LoadUserAction } from "@core/store/user/user.actions";
import { filter, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";

export const AUTHORIZATION_SERVICE = new InjectionToken(
  "AUTHORIZATION_SERVICE",
);

@Injectable()
export class AuthorizationService {
  private readonly authorized$: Observable<boolean>;

  constructor(
    private store: Store<fromRoot.AppState>,
    private router: Router,
    private notificationService: NotificationsService,
    private translate: TranslateService,
  ) {
    this.authorized$ = store.select(fromRoot.getHasActiveSubscription);
  }

  public verificationShouldHappen(response: HttpErrorResponse): boolean {
    return response.status === 403;
  }

  public verifySubscription() {
    this.notAuthorized();
  }

  public isAuthorized(): Observable<boolean> {
    return this.authorized$.pipe(
      tap((isAuthorized) => {
        if (!isAuthorized) {
          this.notAuthorized();
        }
      }),
    );
  }

  /**
   * Not authorized, show notification and redirect
   */
  public notAuthorized() {
    // notification not authorized
    this.notificationService.error(
      this.translate.instant(
        "account.subscriptions.notifications.expired.title",
      ),
      this.translate.instant(
        "account.subscriptions.notifications.expired.text",
      ),
    );

    console.log("not authorized, redirecting to account page");
    // not authorized, go to account page
    this.router.navigate(["/dashboard/account"]);
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/auth/authorization.service.ts